export enum layoutTypes {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
}

export enum layoutTheme {
  LIGHTMODE = "light",
  DARKMODE = "dark",
  GREENMODE = "green",
  PURPLEMODE = "purple"
}

export enum layoutWidthTypes {
  FLUID = "fluid",
  BOXED = "boxed",
}

export enum layoutPositions {
  SCROLLABLE_TRUE = "true",
  SCROLLABLE_FALSE = "false"
}

export enum topBarThemeTypes {
  LIGHT = "light",
  DARK = "dark",
  GREEN = "green",
  PURPLE = "purple"
}

export enum leftSidebarTypes {
  DEFAULT = "lg",
  COMPACT = "md",
  ICON = "sm",
}

export enum leftSideBarThemeTypes {
  LIGHT = "light",
  COLORED = "brand",
  DARK = "dark",
}